/**
 * Landing sayfasının modül ANLATIMI — ad, ikon, özellik listesi, kime uygun.
 *
 * ⚠️ BURADAKİ FİYATLAR ÇALIŞMA ANINDA EZİLİYOR. Fiyatın, deneme süresinin ve
 * satılabilirliğin tek kaynağı backend'deki `module_catalog` (C11):
 * `GET /public/module-catalog` ucundan okunuyor ve `useModuleCatalog` bu
 * nesnelerin üzerine biniyor. Buradaki değerler yalnızca İLK ÇİZİM için —
 * `AVAILABLE_MODULES` tohumuyla aynı. API cevap veremezse vitrin bayat ama
 * çalışır kalıyor; boş fiyat göstermekten iyidir.
 *
 * Yani panelden yapılan zam için bu dosyaya DOKUNULMASI gerekmiyor. Yeni bir
 * modül eklendiğinde ise gerekiyor: adı, ikonu ve özellik listesi ticari
 * veriden türetilemiyor, buraya yazılmadıkça vitrinde çıkmaz.
 *
 * `purchasable: false` olan modül satılamaz — backend `isModulePurchasable`
 * ile bunu uyguluyor ve public uç onu HİÇ döndürmüyor. Vitrinde "Yakında"
 * olarak gösterilir, fiyat sayfasında çıkmaz: fiyat gösterip satın
 * aldıramamak en kötü ikilem.
 */

export const modules = [
  {
    id: 'qr-menu',
    moduleName: 'qr_menu',
    path: '/qr-menu',
    name: 'QR Menü',
    subtitle: 'Sürekli Ücretsiz',
    icon: 'QrCode',
    color: 'bg-green-500',
    badge: 'ÜCRETSİZ',
    purchasable: true,
    price: { monthly: 0, yearly: 0 },
    trialDays: null,
    description: 'Temassız dijital menü. Kurulumu dakikalar sürer, hiçbir ücret yok.',
    ideal: 'Dijitale ilk adımı atan tüm işletmeler',
    features: [
      '8 hazır tema — panelde gerçek menünüzle canlı önizleme',
      'Sınırsız kategori ve ürün',
      'Ürün görselleri, porsiyon ve varyant gösterimi',
      'Anlık fiyat ve stok durumu güncellemesi',
      'Masa ve alan bazlı karekod üretimi',
      'Mobil öncelikli, uygulama indirtmeyen tasarım'
    ],
    highlights: [
      { label: 'Aylık ücret', value: '0 ₺' },
      { label: 'Ürün sınırı', value: 'Yok' },
      { label: 'Tema', value: '8 adet' }
    ],
    demoLink: 'https://menu.cafeotomasyonu.com/demo-kafe',
    ctaText: 'Ücretsiz Kullan',
    learnMore: { href: '/ar-menu', label: 'Pro ile 3D/AR menü' }
  },
  {
    id: 'qr-order',
    moduleName: 'qr_order',
    // Yol `/qr-order` KALIYOR: yayınlanmış bir adres, dış bağlantılar ve arama
    // motoru ona bağlı. Ürünün adı değişti, adresi değil.
    path: '/qr-order',
    name: 'QR Menü Pro',
    subtitle: '3D/AR Menü, Masadan Sipariş, Garson Çağır',
    icon: 'ScanLine',
    color: 'bg-teal-500',
    badge: 'YENİ',
    purchasable: true,
    price: { monthly: 499, yearly: 4990 },
    trialDays: 30,
    description:
      'Misafir yemeği telefonunda 3D görür, AR ile masasına koyar; siparişini kendi verir, garsonu ve hesabı masadan çağırır.',
    ideal: 'Menüsüyle öne çıkmak ve yoğun salonda garson başına düşen masa sayısını artırmak isteyenler',
    // ⚠️ Yalnızca ÇALIŞAN özellik yazılır. Masadan ödeme hazır olana kadar
    // "yakında" — satılmış ama çalışmayan özellik, olmayandan pahalı (C8).
    features: [
      'Yemek 3D döner, "AR\'da Gör" ile gerçek boyutunda masaya oturur — uygulama kurulmadan',
      'Kendi yemeğinizin 3D taraması ürün başına tek seferlik hizmet — ekibimiz yapar',
      'Hazır model kütüphanesi (içecek, tatlı gibi standart ürünler) — yakında',
      'Masadan karekodla sipariş — menüyle aynı ekranda, varsayılan olarak garson onayı bekler',
      'Garson çağır ve hesap iste (kayıt olarak düşer, bildirim olarak değil)',
      'POS salon ekranında misafir çağrı şeridi, bekleme süresi renkli',
      'Masadan kartla ödeme — yakında'
    ],
    highlights: [
      { label: 'Aylık', value: '499 ₺' },
      { label: 'Deneme', value: '30 gün' },
      { label: 'AR', value: 'Uygulamasız' }
    ],
    demoLink: 'https://menu.cafeotomasyonu.com/demo-kafe',
    ctaText: 'Demo İncele',
    // Paketin öne çıkan yeteneğinin kendi sayfası var; modül sayfası ona
    // bağlanmazsa ziyaretçi 3D modeli hiç görmeden fiyata bakıp çıkıyor.
    learnMore: { href: '/ar-menu', label: '3D/AR menüyü görün' }
  },
  {
    id: 'pos-system',
    moduleName: 'pos',
    path: '/pos-system',
    name: 'POS Sistemi',
    subtitle: 'Adisyon, Kasa, Mutfak',
    icon: 'CreditCard',
    color: 'bg-blue-500',
    purchasable: true,
    price: { monthly: 399, yearly: 3990 },
    trialDays: 30,
    description: 'Salondan kasaya tüm operasyon. İnternet kesilse bile adisyon durmaz.',
    ideal: 'Masada servis yapan tüm işletmeler',
    features: [
      'Masa alanı, masa taşıma, hızlı satış (masasız)',
      'Kurs (servis sırası), ikram, iskonto, sebepli iptal',
      '4 tip hesap bölme, parçalı ödeme, para üstü, bahşiş',
      'Kasa/vardiya açılış-kapanış, beklenen-sayılan farkı',
      'Mutfak ekranı (KDS) ve istasyona göre bölünen mutfak fişi',
      'Masaüstü kasa uygulaması + ESC/POS fiş yazıcısı',
      'Çevrimdışı çalışma — kablo çekilse bile sipariş ve nakit ödeme',
      'Personel PIN girişi, rol bazlı yetki, müdür onayı'
    ],
    highlights: [
      { label: 'Aylık', value: '399 ₺' },
      { label: 'Deneme', value: '30 gün' },
      { label: 'Çevrimdışı', value: 'Var' }
    ],
    demoLink: 'https://panel.cafeotomasyonu.com',
    ctaText: 'Demo İncele'
  },
  {
    id: 'online-order',
    moduleName: 'delivery',
    path: '/online-order',
    name: 'Online Sipariş & Paket Servis',
    subtitle: 'Komisyonsuz Kendi Kanalınız',
    icon: 'ShoppingCart',
    color: 'bg-primary',
    popular: true,
    purchasable: true,
    price: { monthly: 1199, yearly: 11990 },
    trialDays: 30,
    description: 'Kendi sipariş siteniz. Aracı yok, komisyon yok, müşteri verisi sizde kalır.',
    ideal: 'Paket servis ve gel-al yapan işletmeler',
    features: [
      'Markanıza ait online sipariş sitesi (kendi adresinizle)',
      'Teslimat bölgesi, minimum sepet, servis saatleri',
      'iyzico ile 3D Secure online ödeme',
      'Adres kaydı, harita ve mesafe bazlı teslimat kontrolü',
      'Müşteri hesabı, sipariş geçmişi ve canlı durum takibi',
      'Web push bildirimi — müşteri siparişinin durumunu anında görür',
      'Onaylanan paket sipariş doğrudan mutfağa düşer'
    ],
    highlights: [
      { label: 'Aylık', value: '1.199 ₺' },
      { label: 'Komisyon', value: 'Yok' },
      { label: 'Deneme', value: '30 gün' }
    ],
    demoLink: 'https://online.cafeotomasyonu.com/demo-kafe',
    ctaText: 'Demo İncele'
  },
  {
    id: 'courier-system',
    moduleName: 'courier',
    path: '/courier-system',
    name: 'Kurye Takip',
    subtitle: 'Atama ve Teslimat Takibi',
    icon: 'Truck',
    color: 'bg-red-500',
    purchasable: true,
    price: { monthly: 799, yearly: 7990 },
    trialDays: 30,
    description: 'Siparişi kuryeye atayın, teslimatı ve kurye kazancını tek yerden izleyin.',
    ideal: 'Kendi kuryesiyle çalışan işletmeler',
    features: [
      'Kurye tanımı, sipariş atama, kabul/red akışı',
      'Teslimat durumu ve teslim süresi takibi',
      'Kurye bazlı kazanç ve performans raporu',
      'Müşteriye teslimat durumu bildirimi',
      'Kurye mobil uygulaması (yayına hazırlanıyor)'
    ],
    highlights: [
      { label: 'Aylık', value: '799 ₺' },
      { label: 'Deneme', value: '30 gün' },
      { label: 'Kurye', value: 'Sınırsız' }
    ],
    demoLink: 'https://panel.cafeotomasyonu.com',
    ctaText: 'Demo İncele'
  },
  {
    id: 'loyalty',
    moduleName: 'loyalty',
    path: '/loyalty',
    name: 'Sadakat Puanı',
    subtitle: 'Telefonla Tanıma',
    icon: 'Gift',
    color: 'bg-pink-500',
    badge: 'YENİ',
    purchasable: true,
    price: { monthly: 299, yearly: 2990 },
    trialDays: 30,
    description: 'Müşteri telefon numarasıyla tanınır, puanı kasada anında indirime döner.',
    ideal: 'Düzenli müşteri kitlesi olan kafe ve restoranlar',
    features: [
      'Kart yok, uygulama yok — telefon numarası yeter',
      '1 puan = 1 kuruş; kasiyerin ezberleyeceği çevrim tablosu yok',
      'Puan tahsil edilen tutar üzerinden kazanılır (iskonto iki kez ödenmez)',
      'Kazanım oranı firma ayarı',
      'POS ekranında bakiye görünür, puan tek dokunuşla harcanır',
      'Aynı adisyondan çift kazanım veritabanı seviyesinde engelli'
    ],
    highlights: [
      { label: 'Aylık', value: '299 ₺' },
      { label: 'Deneme', value: '30 gün' },
      { label: '1 puan', value: '1 kuruş' }
    ],
    demoLink: 'https://panel.cafeotomasyonu.com',
    ctaText: 'Demo İncele'
  },
  {
    id: 'account-management',
    moduleName: 'accountManagement',
    path: '/cari-finans',
    name: 'Cari, Finans & Ortaklık',
    subtitle: 'Çift Taraflı Defter',
    icon: 'Landmark',
    color: 'bg-indigo-500',
    badge: 'YENİ',
    purchasable: true,
    price: { monthly: 599, yearly: 5990 },
    trialDays: 30,
    description: 'İşletmenin parası muhasebe defteri mantığıyla tutulur: bakiye bir alan değil, hareketlerin toplamıdır.',
    ideal: 'Ortaklı işletmeler ve tedarikçiyle cari çalışanlar',
    features: [
      'Cari kart (müşteri, tedarikçi, personel), borç-alacak, ekstre',
      'Gider, tahsilat ve fatura belgesi — boşluksuz numaralandırma',
      'Çift taraflı defter: her kayıt en az iki satır, borç = alacak',
      'Silme yok, ters kayıt var — geçmiş olduğu gibi durur',
      'Ortaklık: üç katılım biçimi (kâr-gider, sessiz ortak, ciro payı)',
      'Sermaye iadesi, dönem kapanışı, ortaklar arası mahsup',
      'Şube bazlı kâr-zarar karşılaştırması'
    ],
    highlights: [
      { label: 'Aylık', value: '599 ₺' },
      { label: 'Deneme', value: '30 gün' },
      { label: 'Defter', value: 'Çift taraflı' }
    ],
    demoLink: 'https://panel.cafeotomasyonu.com',
    ctaText: 'Demo İncele'
  },
  {
    id: 'ai-system',
    moduleName: 'ai',
    path: '/ai-system',
    name: 'Yapay Zeka',
    subtitle: 'Analiz ve Öneri',
    icon: 'Brain',
    color: 'bg-orange-500',
    purchasable: true,
    price: { monthly: 999, yearly: 9990 },
    trialDays: 15,
    description: 'Verinizi rapora değil, karara çeviren yapay zeka katmanı.',
    ideal: 'Sayılara bakacak vakti olmayan işletme sahipleri',
    features: [
      'Satış tahmini ve anormallik tespiti',
      'Menü matrisi ve fiyatlandırma önerisi',
      'Stok optimizasyonu ve müşteri segmentasyonu',
      'Günlük işletme özeti',
      'Ürün ve kategori açıklaması, pazarlama metni üretimi',
      'Yorum analizi ve işletme danışmanı sohbeti'
    ],
    highlights: [
      { label: 'Aylık', value: '999 ₺' },
      { label: 'Deneme', value: '15 gün' },
      { label: 'Analiz', value: '14 uç' }
    ],
    demoLink: 'https://panel.cafeotomasyonu.com',
    ctaText: 'Demo İncele'
  },
  {
    id: 'marketplace',
    moduleName: 'marketplace',
    path: null,
    name: 'Pazaryeri Entegrasyonu',
    subtitle: 'Yemeksepeti · Trendyol Go · Getir',
    icon: 'ShoppingBag',
    color: 'bg-amber-500',
    badge: 'YAKINDA',
    // ⚠️ Satışa KAPALI: adaptörler gerçek platform API'sine bağlı değil,
    // partnership bekleniyor. Fiyat gösterilmiyor — alınamayan bir modülün
    // fiyatını göstermek talep yaratıp karşılığını verememek demek.
    purchasable: false,
    price: { monthly: 1499, yearly: 14990 },
    trialDays: 30,
    description: 'Platform siparişlerinin tek panele düşmesi. Platform anlaşmaları tamamlanınca açılacak.',
    ideal: 'Pazaryeri üzerinden satış yapan işletmeler',
    features: [
      'Platform siparişlerinin POS ve mutfağa düşmesi',
      'Ürün eşleştirme ve toplu menü aktarımı',
      'Anlık ürün açma/kapatma',
      'Platform bazlı satış raporu'
    ],
    highlights: [],
    demoLink: null,
    ctaText: 'Haber Ver'
  },
  {
    id: 'whatsapp',
    moduleName: 'whatsapp',
    path: '/whatsapp-order',
    name: 'WhatsApp Sipariş',
    subtitle: 'Kendi hattınızdan sipariş',
    icon: 'MessageCircle',
    color: 'bg-green-500',
    badge: 'YENİ',
    purchasable: true,
    price: { monthly: 599, yearly: 5990 },
    trialDays: 30,
    description: 'Müşteri sizin bildiği numaraya yazıyor; sipariş elle POS\'a girilmek yerine kayıtlı bir kanal olarak sisteme düşüyor.',
    ideal: 'Siparişin çoğunu WhatsApp\'tan alan işletmeler',
    features: [
      'İşletmenin kendi numarası — resmi API ya da karekodla eşleşme',
      'Otomatik karşılama ve sipariş bağlantısı',
      'Sipariş durumu bildirimi (hazırlanıyor, yolda, teslim)',
      'Panelde gelen kutusu ve manuel yanıt',
      'Şube başına ayrı numara'
    ],
    highlights: [
      { label: 'Aylık', value: '599 ₺' },
      { label: 'Deneme', value: '30 gün' },
      { label: 'Kurulum', value: 'Kendi numaranız' }
    ],
    demoLink: null,
    ctaText: 'Detayları İncele'
  }
];

/** Fiyat vitrini: 0 ise "Ücretsiz", değilse binlik ayraçlı ₺. */
export const formatPrice = (amount) =>
  amount === 0 ? 'Ücretsiz' : `${amount.toLocaleString('tr-TR')} ₺`;
